module.exports = __webpack_public_path__ + "assets/img/2806.db31905e.svg";